const Constants = {
    STORAGE_USER_KEY: 'userInfo',
    STAGING: 'stage',
    PRODUCTION: 'prod',
    OAUTH_RESPONSE_KEY: 'custom-oauth-external',
    OAUTH_KEY: 'oauth_external'
};

export default Constants;